<script lang="ts" setup>
import { storeToRefs } from "pinia";
import H1Heading from "~/components/H1Heading.vue";
import CredentialLogos from "~/components/home/CredentialLogos.vue";
import RecentlyViewed from "~/components/home/RecentlyViewed.vue";
import SalesTeam from "~/components/home/SalesTeam.vue";
import SearchProducts from "~/components/product/SearchProducts.vue";
import { useSearchStore } from "~/store/search";

const { selectedState } = storeToRefs(useSearchStore());
</script>

<template>
    <div>
        <H1Heading
            size="text-3xl md:text-4xl"
            class="relative"
        >
            Shop All</H1Heading
        >
        <div class="mb-6 pt-4 text-center text-base font-medium md:pt-0 md:text-xl xl:text-3xl">
            Need to download a quote? Add items to your cart to begin.
        </div>

        <SearchProducts class="mb-20" />

        <RecentlyViewed />
        <hr class="my-10" />
        <CredentialLogos />
        <hr class="my-10" />
        <SalesTeam :state="selectedState" />
    </div>
</template>

<style scoped></style>
